import Vue from "vue";
import Vuex from "vuex";
// import axios from "axios";
import VuexPersistence from "vuex-persist";
// import localForage from 'localforage';
// import db from "../database";
// import * as msg from "../message";
import * as helper from "../helper";
import Catalog from "../store/modules/catalog";
import Notifications from "../store/modules/notifications";
import System from "../store/modules/system";
import Sessions from "../store/modules/sessions";
import Billing from "../store/modules/billing";
import Offline from "../store/modules/offline";
import Stock from "../store/modules/stock";
import GiftVoucher from "../store/modules/giftVoucher";
import Extra from "../store/modules/extra";

Vue.use(Vuex);

const vuexProducts = new VuexPersistence({
  key: "delta",
  storage: window.localStorage,
  modules: ["products"],
});

const vuexNotifications = new VuexPersistence({
  key: "rogers",
  storage: window.localStorage,
  modules: ["notifications"],
});

const vuexSystem = new VuexPersistence({
  key: "base-camp",
  storage: window.localStorage,
  modules: ["system"],
});

const vuexSessions = new VuexPersistence({
  key: "operations",
  storage: window.localStorage,
  modules: ["sessions"],
});

const vuexBilling = new VuexPersistence({
  key: "mission",
  storage: window.localStorage,
  modules: ["billing", "offline", "stock", "giftVoucher"],
});

const vuexExtra = new VuexPersistence({
  key: "iota",
  storage: window.localStorage,
  modules: ["extra"],
});

export default new Vuex.Store({
  mutations: {
    clearState(state) {
      state.sessions.organisation_id = 0;
      state.sessions.user_id = 0;
      state.sessions.user = {};
      state.billing.billing.dumuy_customer = "";
      state.notifications.error = "";

      state.sessions.loading = false;
      state.sessions.user.v_id = "";
      state.sessions.user.vu_id = "";
      state.system.api_token = "";
      state.sessions.user.store_id = "";
      state.system.settings = "";
      state.sessions.user = {};
      state.notifications.error = "";
      state.sessions.forceLogin = 0;
      // state.theme = "theme-light";
      // state.printer = "";
      // state.weightPort = "";
      // state.mp200Port = "";
      state.system.last_setting_invoked = "";
      state.sessions.session.last_session_print_data = "";
      state.system.device_name = "";
      state.sessions.session = {
        time: "",
        username: "",
        type: "",
        required: "",
        denomination: "",
        id: 0,
      };
      // state.isMsg = "";
      state.system.is_catalog = 0;
      state.notifications.showAlert = {
        type: "",
        message: "",
      };
      state.notifications.message = {
        text: "",
        btnText: "",
        type: "",
      };
      state.billing.billing = {
        customer: {
          address: "",
          data: "",
          summary: "",
        },
        order: {
          data: "",
          summary: "",
        },
        dumuy_customer: "",
        cart: "",
        subtotal: "0.00",
        discount: "0.00",
        taxes: "0.00",
        carry_bags: "0.00",
        carry_bag_qty_total: "0",
        total_payable: "0.00",
        total_qty: 0,
        layby_amount: 0,
        remark: "",
        salesPerson: {
          data: [],
          selected: "",
        },
        vocher_list: [],
        invoice: {
          data: "",
          summary: "",
          print_url: "",
          print_data: "",
        },
        layBy_Amt: 0,
        invoice_no: "",
        order_no_hold: "",
        order_no: "",
        refund_mode: false,
        on_account: {},
        pay_balance_deposit: {
          trans_sub_type: "",
          transaction_summary: {},
          customer: {},
          save_payment_data: {},
          print_data: "",
          print_html: "",
        },
      };
      state.billing.return_flow = {
        customer_info: "",
        invoice: "",
        product_list: [],
        remarks: "",
        return_confirm_data: {},
        return_invoice: {},
      };
      state.products.progress = {
        current: 0,
        max: 0,
      };
      state.offline.sync_loading = false;
      state.billing.billing.invoice_no = "";
      state.billing.billing.order_no = "";
      state.billing.billing.order_no_hold = "";
      state.system.forceOffline = false;
      state.system.payment_integrations.phonepe.transaction_id = "";
      state.offline.last_sync_time = {
        user_master: "",
        setting_master: "",
        session_master: "",
        item_master: "",
      };
      state.extra = {
        states: [],
      };
      state.billing.orderPos.due_date = "";
    },
    clearOnRevokeLic(state) {
      state.system.country_details = {};
      state.system.licence = "";
    },
  },
  getters: {
    isLoggedIn: (state) => !!state.sessions.user.api_token,
    isOMSEnabled(state) {
      let check = false;
      if (
        state.system.settings.order.hasOwnProperty("oms") &&
        state.system.settings.order.oms.DEFAULT.status == 1
      ) {
        check = true;
      }
      return check;
    },
    isOmsMiniAmount(state, rootGetters) {
      let check = {
        status: false,
        amount: 0,
      };
      let billAmount = 0;
      let minAmt = {
        amt: 0,
        percentage: 0,
      };

      if (state.billing.billing.order.data.hasOwnProperty("is_payment")) {
        billAmount = state.billing.billing.order.data.total;
      } else {
        billAmount = state.billing.billing.cart.total;
      }
      if (rootGetters.isOMSEnabled) {
        let options = state.system.settings.order.oms.DEFAULT.options;
        if (
          options[0].hasOwnProperty("is_advance_mandatory") &&
          options[0].is_advance_mandatory.status
        ) {
          check.status = true;
          minAmt.percentage = !helper.isEmpty(
            options[0].is_advance_mandatory.internal_options.percentage.value
          )
            ? (parseFloat(billAmount) *
                parseFloat(
                  options[0].is_advance_mandatory.internal_options.percentage
                    .value
                )) /
              100
            : 0;
          minAmt.amt = !helper.isEmpty(
            parseFloat(
              options[0].is_advance_mandatory.internal_options.amount.value
            )
          )
            ? parseFloat(
                options[0].is_advance_mandatory.internal_options.amount.value
              )
            : 0;

          check.amount =
            minAmt.percentage <= minAmt.amt ? minAmt.percentage : minAmt.amt;
          // check.amount =
          //   parseFloat(check.amount) >
          //   parseFloat(state.billing.billing.order.data.total) ?
          //   state.billing.billing.order.data.total :
          //   check.amount;
        }
      }

      return check;
    },
    orderPaymentMode(state) {
      return !state.billing.billing.order.data.hasOwnProperty("is_payment") &&
        !["Refund-CN", "Credit-Note", "Deposit-DN"].includes(
          state.billing.billing.order.data.trans_sub_type
        ) &&
        state.billing.trans_sub_type != "order"
        ? true
        : false;
    },
    checkStock: (state) => {
      let res = {
        available: 0,
        unavailable: 0,
      };
      let productList = state.billing.billing.cart.data;
      if (
        state.billing.billing.cart.hasOwnProperty("data") &&
        state.billing.billing.cart.data.length !== 0
      ) {
        productList.map((item) => {
          if (item.product_data.current_stock > 0) {
            res.available += 1;
          } else {
            res.unavailable += 1;
          }
        });
      }
      return res;
    },
    checkInvoiceSuccess(state) {
      let invoice = state.billing.billing.invoice;
      if (invoice.data != "") {
        if (
          state.billing.billing.total_payable == 0 ||
          state.billing.billing.total_payable == "0.00"
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    omsSettings(state, rootGetters) {
      let res = {
        refund_mode: {
          cash: false,
          credit_note: false,
        },
        is_replaced: false,
        is_discard: false,
      };
      if (rootGetters.isOMSEnabled) {
        let optionList = state.system.settings.order.oms.DEFAULT.options[0];
        if (optionList["refund_mode"]) {
          res.refund_mode.cash =
            optionList["refund_mode"].internal_options.cash.status;
          res.refund_mode.credit_note =
            optionList["refund_mode"].internal_options.store_credit_note.status;
        }
        if (optionList["replace_product"]) {
          res.is_replaced = optionList["replace_product"].status;
        }
        if (optionList["discard_product"]) {
          res.is_discard = optionList["discard_product"].status;
        }
      }
      return res;
    },
    omsInventoryBlockingLevel(state) {
      return state.system.settings.order.oms.DEFAULT.options[0]
        .inventory_blocking_level.value;
    },
  },
  modules: {
    products: Catalog,
    notifications: Notifications,
    system: System,
    sessions: Sessions,
    billing: Billing,
    offline: Offline,
    stock: Stock,
    giftVoucher: GiftVoucher,
    extra: Extra,
  },
  plugins: [
    vuexProducts.plugin,
    vuexNotifications.plugin,
    vuexSystem.plugin,
    vuexSessions.plugin,
    vuexBilling.plugin,
    vuexExtra.plugin,
  ],
});
